import {definePreset, palette} from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const MyPreset = definePreset(Aura, {
  semantic: {
    primary: palette('blue'),
    colorScheme: {
      light: {
        primary: {
          color: 'rgba(0, 52, 89, 1)',
          inverseColor: '#ffffff',
          hoverColor: '{indigo.200}',
          activeColor: '{indigo.800}',
        },
        highlight: {
          background: '{indigo.200}',
          focusBackground: '{indigo.200}',
          color: 'var(--p-text-color)',
          focusColor: '#ffffff',
        },
      },
      dark: {
        primary: {
          color: '{indigo.500}',
          inverseColor: '#ffffff',
          hoverColor: '{indigo-400}',
          activeColor: '{indigo.200}',
        },
        highlight: {
          background: 'rgba(250, 250, 250, .16)',
          focusBackground: 'rgba(250, 250, 250, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
      },
    }
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            primary: {
              background: '{indigo.600}',
              color: 'white',
              borderColor: '{indigo.600}'
            },
            secondary: {
              color: 'var(--color-gray-400)'
            }
          }
        },
        dark: {
          root: {
            primary: {
              color: 'white'
            },
            secondary: {
              color: 'var(--color-gray-400)'
            }
          }
        }
      }
    }
  }
});

export const EDITOR_ACTIVITIES = {
  colorScheme: {
    light: {
      root: {
        style: {
          display: 'flex',
          flexDirection: 'column-reverse',
          border: '1px solid oklch(0.872 0.01 258.338)',
          borderRadius: '6px'
        }
      },
      toolbar: {
        style: {
          borderTop: '1px solid oklch(0.872 0.01 258.338)',
          borderTopLeftRadius: '0px',
          borderTopRightRadius: '0px',
          borderBottom: 'none',
          borderLeft: 'none',
          borderRight: 'none',
          borderBottomLeftRadius: '6px',
          borderBottomRightRadius: '6px'
        }
      },
      content: {
        style: {
          border: 'none',
          borderTopLeftRadius: '6px',
          borderTopRightRadius: '6px',
          overflow: 'hidden'
        }
      }
    },
    dark: {
      root: {
        style: {
          display: 'flex',
          flexDirection: 'column-reverse',
          border: '1px solid rgb(63, 63, 70)',
          borderRadius: '6px'
        }
      },
      toolbar: {
        style: {
          borderTop: '1px solid rgb(63, 63, 70)',
          borderTopLeftRadius: '0px',
          borderTopRightRadius: '0px',
          borderBottom: 'none',
          borderLeft: 'none',
          borderRight: 'none',
          borderBottomLeftRadius: '6px',
          borderBottomRightRadius: '6px'
        }
      },
      content: {
        style: {
          border: 'none',
          borderTopLeftRadius: '6px',
          borderTopRightRadius: '6px',
          overflow: 'hidden'
        }
      }
    }
  }
}

export const HAMBURGER_BTN = {
  colorScheme: {
    light: {
      root: {
        secondary: {
          background: 'transparent',
          borderColor: 'transparent',
          color: 'var(--color-white)'
        }
      }
    },
    dark: {
      root: {
        secondary: {
          color: 'var(--color-gray-400)'
        }
      }
    }
  }
}

export const BUTTON_NAV = {
  colorScheme: {
    light: {
      text: {
        secondary: {
          color: 'white',
          hoverBackground: 'var(--p-blue-300)',
        }
      }
    },
    dark: {
      text: {
        secondary: {
          color: 'var(--color-gray-400)',
          hoverBackground: 'var(--p-surface-700)'
        }
      }
    }
  }
}

export const BUTTON_NAV_MOBILE = {
  colorScheme: {
    light: {
      text: {
        secondary: {
          color: 'var(--color-gray-700)',
          hoverBackground: 'var(--p-blue-300)',
        }
      }
    },
    dark: {
      text: {
        secondary: {
          color: 'var(--color-gray-400)',
          hoverBackground: 'var(--p-surface-700)'
        }
      }
    }
  }
}

export const AVATAR = {
  colorScheme: {
    light: {
      root: {
        background: 'white'
      }
    },
    dark: {
      root: {
        background: 'var(--p-surface-700)'
      }
    }
  }
}

export const AVATAR_MOBILE = {
  colorScheme: {
    light: {
      root: {
        background: 'var(--color-gray-400)',
        color: 'white'
      }
    },
    dark: {
      root: {
        background: 'var(--p-surface-700)'
      }
    }
  }
}

export const MENUBAR = {
  colorScheme: {
    light: {
      root: {
        background: 'rgba(0, 52, 89, 1)',
        borderColor: 'rgba(0, 52, 89, 1)',
        color: 'white'
      },
      submenu: {
        background: 'rgba(0, 52, 89, 1)',
        icon: {
          color: 'white',
        }
      },
      item: {
        color: 'white',
        focusBackground: 'var(--p-blue-300)',
        gap: '.5rem',
        icon: {
          color: 'white'
        }
      }
    },
    dark: {
      root: {
        background: 'transparent',
        borderColor: 'transparent',
        color: 'white'
      },
      submenu: {
        background: 'var(--p-surface-800)',
        icon: {
          color: 'var(--color-gray-400)',
        }
      },
      item: {
        color: 'var(--color-gray-400)',
        focusBackground: 'transparent',
        gap: '.5rem',
        icon: {
          color: 'var(--color-gray-400)'
        }
      }
    }
  }
}

export const MENUBAR_MOBILE = {
  colorScheme: {
    light: {
      root: {
        background: 'transparent',
        borderColor: 'transparent',
        color: 'var(--color-gray-700)'
      },
      submenu: {
        background: 'white',
        icon: {
          color: 'black',
        }
      },
      item: {
        color: 'var(--color-gray-700)',
        focusBackground: 'var(--p-gray-200)',
        gap: '.5rem',
        icon: {
          color: 'white'
        }
      }
    },
    dark: {
      root: {
        background: 'transparent',
        borderColor: 'transparent',
        color: 'white'
      },
      submenu: {
        background: 'var(--p-surface-900)',
        borderColor: 'transparent',
        icon: {
          color: 'var(--color-gray-400)',
        }
      },
      item: {
        color: 'var(--color-gray-400)',
        focusBackground: 'transparent',
        gap: '.5rem',
        icon: {
          color: 'var(--color-gray-400)'
        }
      }
    }
  }
}

export const PANELMENU = {
  colorScheme: {
    light: {
      root: {
        gap: 0
      },
      panel: {
        background: 'transparent',
        first: {
          borderWidth: 0
        },
        borderWidth: 0,
        last: {
          borderWidth: 0
        }
      },
      item: {
        color: 'white',
        focusBackground: 'var(--p-blue-300)',
        gap: '.5rem',
        icon: {
          color: 'white'
        }
      },
      submenu: {
        indent: '1.5rem'
      },
      submenuIcon: {
        color: 'white'
      }
    },
    dark: {
      root: {
        gap: 0
      },
      panel: {
        background: 'transparent',
        first: {
          borderWidth: 0
        },
        borderWidth: 0,
        last: {
          borderWidth: 0
        }
      },
      item: {
        color: 'var(--color-gray-400)',
        focusBackground: 'transparent',
        gap: '.5rem',
        icon: {
          color: 'var(--color-gray-400)'
        }
      },
      submenu: {
        indent: '1.5rem'
      },
      submenuIcon: {
        color: 'white'
      }
    }
  }
}

export const TAG_STATUS = {
  colorScheme: {
    light: {
      success: {
        background: 'rgb(59, 130, 246)',
        color: 'white'
      },
      primary: {
        background: 'rgb(22, 163, 74)',
        color: 'white'
      },
      warn: {
        background: 'rgb(251, 191, 36)',
        color: 'dark-gray'
      },
      danger: {
        background: 'var(--p-surface-500)',
        color: 'white'
      }
    },
    dark: {
      success: {
        background: 'rgb(59, 130, 246)',
        color: 'white'
      },
      primary: {
        background: 'rgb(22, 163, 74)',
        color: 'white'
      },
      warn: {
        background: 'rgb(251, 191, 36)',
        color: 'var(--p-surface-700)'
      },
      danger: {
        background: 'var(--p-surface-700)',
        color: 'dark-gray'
      }
    }
  }
}

export const TAG_PRIORITY = {
  colorScheme: {
    light: {
      info: {
        background: 'var(--p-blue-400)',
        color: 'white'
      },
      success: {
        background: 'var(--p-green-400)',
        color: 'white'
      },
      warn: {
        background: 'var(--p-orange-400)',
        color: 'white'
      },
      danger: {
        background: 'var(--p-red-400)',
        color: 'white'
      },
      contrast: {
        background: 'var(--p-gray-400)',
        color: 'white'
      }
    },
    dark: {
      info: {
        background: 'var(--p-blue-400)',
        color: 'white'
      },
      success: {
        background: 'var(--p-green-400)',
        color: 'white'
      },
      warn: {
        background: 'var(--p-orange-400)',
        color: 'white'
      },
      danger: {
        background: 'var(--p-red-400)',
        color: 'white'
      },
      contrast: {
        background: 'var(--p-gray-400)',
        color: 'white'
      }
    }
  }
}

export const TAG_TICKET_STATUS = {
  colorScheme: {
    light: {
      primary: {
        background: 'var(--p-blue-500)',
        color: 'white'
      },
      success: {
        background: 'var(--p-green-500)',
        color: 'white'
      },
      secondary: {
        background: 'var(--p-purple-500)',
        color: 'white'
      },
      info: {
        background: 'var(--p-orange-500)',
        color: 'white'
      },
      contrast: {
        background: 'var(--p-gray-300)',
        color: 'white'
      }
    },
    dark: {
      primary: {
        background: 'rgb(59, 130, 246)',
        color: 'white'
      },
      success: {
        background: 'var(--p-green-700)',
        color: 'white'
      },
      secondary: {
        background: 'var(--p-purple-500)',
        color: 'white'
      },
      info: {
        background: 'var(--p-orange-500)',
        color: 'white'
      },
      contrast: {
        background: 'var(--p-gray-400)',
        color: 'white'
      }
    }
  }
}
